module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_1.535dc72f.png";